module.exports = require("core-js-pure/stable/set-timeout");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/set-timeout.js
// module id = 614
// module chunks = 0